import React from 'react';
import styled from 'styled-components';
import ReactLoading from "react-loading";

const Wrapper = styled.div`
  position: fixed;
  z-index: 99999;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(124 123 126 / 50%);
  bottom: 0;
`;

const Loading = () => (
  <Wrapper>
    <ReactLoading type="spin" color="#fff" />
  </Wrapper>
);

export default Loading;
